import type { RequestAnalyticsContext } from '@/analytics/context';
import { request } from "@umijs/max";

export async function fetchProductsByIngredient(params: any, analyticsContext?: RequestAnalyticsContext, options?: Record<string, any>) {
  const enterpriseSearch = Boolean(
    params?.module_filters && Object.keys(params.module_filters).length > 0,
  );
  return request(
    enterpriseSearch ? '/enterprise/product-search' : '/data/fetch_products_by_ingredient',
    {
    ...options,
    method: 'POST',
    data: params,
    analyticsContext,
    },
  );
}

export async function fetchProductsByIngredientCount(params: {
  countKey: string;
  enterpriseSearch?: boolean;
}, analyticsContext?: RequestAnalyticsContext, options?: Record<string, any>) {
  const { enterpriseSearch, ...data } = params;
  return request(enterpriseSearch ? '/enterprise/product-search/count' : '/data/fetch_products_by_ingredient/count', {
    ...options,
    analyticsContext,
    method: 'POST',
    data,
  });
}

export async function fetchProduct(
  data: any,
  analyticsContext?: RequestAnalyticsContext,
  options?: { signal?: AbortSignal },
) {
  return request('/data/fetch_product', {
    method: 'POST',
    data: data,
    ...(analyticsContext ? { analyticsContext } : {}),
    ...(options?.signal ? { signal: options.signal } : {}),
  });
}

export async function autoCompleteIngredientName(params: any) {
  return request(`/data/autocomplete_ingredients/${encodeURIComponent(params)}`);
}

export async function fetchProductLists() {
  return request('/data/fetch_product_lists');
}

export async function createProductList(params: any) {
  try {
    return await request('/data/create_product_list', {
      method: 'POST',
      data: params,
    });
  } catch (error) {
    throw error;
  }
}

export async function addProductsToList(params: any) {
  return request('/data/add_products_to_list', {
    method: 'POST',
    data: params,
  });
}

export async function fetchProductCategories() {
  return request('/data/product_categories');
}

export async function fetchFilterOptions(params?: { compact?: boolean }) {
  return request('/data/filter_options', {
    params,
  });
}

export async function autoCompleteFilterOption(filter: string, searchText: string) {
  return request(`/data/autocomplete_filter/${filter}/${encodeURIComponent(searchText)}`);
}
